import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { PassengerTableRow_orderRoom$key } from '__generated__/PassengerTableRow_orderRoom.graphql';
import { PassengerTableRow_passenger$key } from '__generated__/PassengerTableRow_passenger.graphql';

type Props = {
  orderRoom: PassengerTableRow_orderRoom$key;
  passenger: PassengerTableRow_passenger$key;
};

const PassengerTableRow: FC<Props> = ({ orderRoom, passenger }) => {
  const { name } = useFragment(
    graphql`
      fragment PassengerTableRow_orderRoom on OrderRoom {
        name
      }
    `,
    orderRoom
  );

  const { fullName, dob, ageOnReturn, roomPrice } = useFragment(
    graphql`
      fragment PassengerTableRow_passenger on Passenger {
        fullName
        dob
        ageOnReturn
        roomPrice
      }
    `,
    passenger
  );

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell align="center">{fullName}</TableCell>
      <TableCell align="center">{dob}</TableCell>
      <TableCell align="center">{ageOnReturn}</TableCell>
      <TableCell align="center">€{roomPrice}</TableCell>
    </TableRow>
  );
};

export default PassengerTableRow;
